export default __webpack_public_path__ + "static/media/winston.67e98a27.webp";